<template>
  <div>
    <div class="mb-10">
      <collapse :multiple-active="false" :active-index="-1">
       
        <collapse-form-item
          id="disbursingCollectionInformationStep"
          title="Transaction Completion"
          @tabOpen="loadItem"
          v-bind:tabChange="getAllState.complete"
          :status="disbursingCollectionInformationStatus || transactionCompletedDocumentStatus"
          name="1"
        >
        <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="tranComp_tooltip_NAME"  :name="tranComp_tooltip_NAME" :description="tranComp_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
          <div>
            <disbursing-collection-information
              :is-read-only="isReadOnly"
              v-on:show-document-tab="showDocumentTab"
              ref="disbursingCollectionInformationStep"
              @validated="onSubStepValidated"
            ></disbursing-collection-information>
          </div>
        </collapse-form-item>
        <collapse-form-item
        id="financialRepresentativeStep"
        title="Financial Representative (Signature)"
        @tabOpen="loadItem"
        :status="financialRepresentativeStatus"
        v-bind:tabChange="getAllState.complete"
        name="2"
      >
        <div>
          <financial-representative
            :is-read-only="isReadOnly"
            v-on:show-document-tab="showDocumentTab"
            ref="financialRepresentativeStep"
            @validated="onSubStepValidated"
          ></financial-representative>
        </div>
      </collapse-form-item>
      </collapse>
    </div>
    <div class="row">
      <div class="col-sm-6 ">
        <el-alert
          v-if="!isOrderComplete && !isPartnerAccount"
          type="warning"
          :closable="false"
          title="Important Information"
          description="On clicking complete, the order will be saved and you will no longer
          be able to make any changes."
          show-icon
          effect="dark"
        >
        </el-alert>
        <br />
        <el-alert
          v-if="!canOrderComplete && !isPartnerAccount"
          type="warning"
          :closable="false"
          title="Important Information"
          description="Cannot complete please review order."
          show-icon
          effect="dark"
        >
        </el-alert>
        <br />
        <el-alert
          v-if="isOrderComplete && !isPartnerAccount"
          type="success"
          :closable="false"
          title="Order Completed"
          :description="completedText"
          show-icon
          effect="dark"
        >
        </el-alert>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import DisbursingCollectionInformation from "@/components/App/order/bill/disbursingcollectioninformation/DisbursingCollectionInformation.vue";
import ReconciliationStatus from '@/components/App/order/completion/ReconciliationStatus.vue'
import FinancialRepresentative from "@/components/App/order/bill/FinancialRepresentative.vue";
import { Select, Option, Alert } from "element-ui";
import { BaseRadio, Collapse, CollapseFormItem } from "@/components/index";
import { EventBus } from "@/event-bus.js";
import toolTip  from "../Tooltip";

export default {
  props: ["completedText", "isReadOnly"],
  components: {
    [Alert.name]: Alert,
    Collapse,
    CollapseFormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
    DisbursingCollectionInformation,
    ReconciliationStatus,
    FinancialRepresentative,
    toolTip
  },
  data() {
    return {
        tranComp_tooltip_NAME : '',
        tranComp_tooltip_DESCRIPTION : '',
        };
    },
    async mounted() {
    await this.getAllTooltips()
    this.loadToolTips()
    },
  computed: {
    ...mapGetters({
      orderStatus: "orderMetadata/orderStatus",
      preOrder: "preOrderDetail/preOrder",
        documents: "documents/getDocuments",
      isMonetaryTransaction: "preOrderDetail/isMonetaryOrder",
      inspectedReceivedBy: "inspectedReceivedBy/inspectedReceivedBy",
      reconciliationStatusInformation: "reconciliationStatus/reconciliationStatusInformation",
      financialRepresentativeStatus: "financialRepresentative/financialRepresentativeStatus",
      disbursingCollectionInformationStatus:
        "disbursingCollectionInformation/disbursingCollectionInformationStatus",
      returnReplacementReceiptAcknowledgment:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgment",
      isPartnerAccount: "authentication/isPartnerAccount",
      getAllState: "moduleState/getAllStates",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
      transactionCompletedDocumentStatus() {
      if (this.uploadedDocumentsStatus && (this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETED") || this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETION"))) {
        return true;
      }
    },
       uploadedDocumentsStatus() {
      if (this.documents && this.documents.length > 0) {
        let uploadedDocuments = [];
        this.documents.forEach((doc) =>
          doc.fileTypeNames.forEach((fileName) =>
            uploadedDocuments.push(fileName)
          )
        );

        return [...new Set(uploadedDocuments)];
      } else {
        return [];
      }
    },
    canOrderComplete() {
      if (this.isMonetaryTransaction) {
        return !this.inspectedReceivedBy.isPartial;
      } else {
        return (
          !this.inspectedReceivedBy.isPartial
        );
      }
    },
    orderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    isOrderComplete() {
      return this.orderStatus == "COMPLETED";
    },
  },
  data() {
    return {
        tranComp_tooltip_NAME : '',
        tranComp_tooltip_DESCRIPTION : '',
        };
    },
  async mounted() {
    this.loadReturnReplacementReceiptAcknowledgment(this.orderIdFromRoute);
    this.getInspectedReceivedBy(this.orderIdFromRoute);
    this.getDisbursingCollectionInformationStatus(this.$route.params.id);
    this.getReconciliationStatusInformation(this.$route.params.id);
    await this.getAllTooltips();
    this.loadToolTips();
  },
  methods: {
    ...mapActions({
      loadReturnReplacementReceiptAcknowledgment:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgment",
      getInspectedReceivedBy: "inspectedReceivedBy/getInspectedReceivedBy",
      getDisbursingCollectionInformationStatus:
        "disbursingCollectionInformation/getDisbursingCollectionInformationStatus",
        getReconciliationStatusInformation: "reconciliationStatus/getReconciliationStatusInformation",
        getReconciliationStatus: "reconciliationStatus/getReconciliationStatus",
        getAllTooltips: "tooltip/getToolTips"
    }),
    loadToolTips(){
    const tranCompVal = this.toolTips.find(e => e.name === "CompletionModule")
    if(tranCompVal.status){
    this.tranComp_tooltip_DESCRIPTION = tranCompVal.description ? tranCompVal.description: null
    this.tranComp_tooltip_NAME = tranCompVal.name ? tranCompVal.name: null
    }
    return 
    
    },
updateToolTip(updatedData){
    this.loadToolTips()
},
    loadItem(ref, isOpen) {
      if(isOpen)
        return this.$refs[ref].loaded();
      else
        return;
    },
    onSubStepValidated(validated, model) {
      this.$emit("on-validated", validated, model);
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
      EventBus.$emit('clicked-from', 'TRANSACTION COMPLETION')

    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },
  },
};
</script>

<style scoped>
@import "../../../styles/custom_grid.css";

.card-collapse .card.card-plain.has-danger .card-header:after {
  background: #ec250d;
}

.card-collapse .card.card-plain.has-success .card-header:after {
  background: #10b45a;
}

.mb-10 {
  margin-bottom: 4em;
}
</style>
